module.exports = __webpack_public_path__ + "img/vip_mb_tab_03.14464bf6.png";